var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPublished)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("已发布")]):_c('el-tag',{attrs:{"type":"primary"}},[_vm._v("草稿")])}
var staticRenderFns = []

export { render, staticRenderFns }